import { CartCalculations, CurrencySymbol } from "@repo/components";
import cx from "classnames";

const PricingDetails = ({
  isPaymentFailed,
  isPaymentCancelled,
  isPaymentPending,
  amounts,
  tCart,
  tCommon,
  tAccount,
  isShippable,
}) => (
  <div className="border-supportiveDarkGray bg-supportiveThinGray mt-4 border">
    <div className="font-heading text-supportiveBlack rtl:font-arabic flex items-center px-3 py-4 text-sm font-medium md:text-xl">
      <span>{tCart("Pricing_Details")}</span>
      <span
        className={cx(
          "font-body ms-auto inline-block border px-2 py-1 text-sm",
          {
            "border-[#C62828] bg-[#FAEAEA] text-[#C62828]": !isShippable,
            "border-mediumgreen bg-lightgreen text-mediumgreen": isShippable,
          }
        )}
      >
        {isPaymentFailed
          ? tCommon("Failed")
          : isPaymentCancelled
            ? tCommon("Cancelled")
            : isPaymentPending
              ? tCommon("Pending")
              : tAccount("Paid")}
      </span>
    </div>
    <CartCalculations summary={amounts} />
    <div className="bg-supportiveThinGray flex p-3">
      <div className="text-supportiveBlack text-lg font-semibold">
        {tCart("Total")}
      </div>
      <div className="text-supportiveBlack ms-auto text-lg font-semibold">
        <CurrencySymbol value={amounts?.formattedTotal} />
      </div>
    </div>
  </div>
);

export default PricingDetails;
